import {
  useState,
  useEffect,
  type Dispatch,
  type SetStateAction,
} from "react";
import IconButton from "components/General/IconButton";
import InfoButton from "components/General/InfoButton";
import ModalWrapper, { OpenInterface } from "components/Wrappers/ModalWrapper";

export default function EmbankmentModal({
  open,
  setOpen,
  setEmbankWR,
  wr=-1,
  clearTool=()=>null,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  wr: number,
  setEmbankWR: Dispatch<SetStateAction<number>>;
  clearTool?: ()=>void,
}) {
  const waterRegimes = [ 1,2,3,4,5 ]

  useEffect(() => {
    if (!open && wr < 0) {
      clearTool();
    }
  }, [wr, open])

  useEffect(() => {
    if (wr >= 0) {
      setOpen(false);
    }
  }, [wr])

  return (
    <ModalWrapper open={open} setOpen={setOpen}>
      <h1 className="text-xl">Create an Embankment</h1>


      <div className="flex flex-row justify-between pb-2">
        <label className="">Select Water Regime</label>
      </div>

      <div className="flex flex-row justify-between border border-black py-2 px-1 mb-4">
        { waterRegimes.map((waterRegime, i) => (
          <IconButton
            icon={`Water Regime ${waterRegime}`}
            key={i}
            onClick={() => {
              setEmbankWR(waterRegime)
            }}
            selected={wr === waterRegime}
          />
        ))}
      </div>
      <img src="/Images/WLregime.png"></img>
    </ModalWrapper>
  )
}
